import axios from 'axios'
export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {

    uploadProofOfAttachment({commit}, paymentLotForm) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/finances/accounts-payable/${paymentLotForm.get('id')}`, paymentLotForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    markAsClosed({commit}, paymentLotForm) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/finances/accounts-payable/${paymentLotForm.get('id')}/markAsClosed`, paymentLotForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
